/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./message-copied.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./message-copied.component";
var styles_MessageCopiedComponent = [i0.styles];
var RenderType_MessageCopiedComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_MessageCopiedComponent, data: {} });
export { RenderType_MessageCopiedComponent as RenderType_MessageCopiedComponent };
export function View_MessageCopiedComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "span", [["class", "box-message"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" URL copied...!!!\n"]))], null, null); }
export function View_MessageCopiedComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-message-copied", [], null, null, null, View_MessageCopiedComponent_0, RenderType_MessageCopiedComponent)), i1.ɵdid(1, 114688, null, 0, i2.MessageCopiedComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MessageCopiedComponentNgFactory = i1.ɵccf("app-message-copied", i2.MessageCopiedComponent, View_MessageCopiedComponent_Host_0, {}, {}, []);
export { MessageCopiedComponentNgFactory as MessageCopiedComponentNgFactory };
